<template>
  <div class="setting-account-account">
    <h2>使用条款</h2>

    <div class="ivu-mt ivu-pl ivu-pr">
      <Divider orientation="left">授权商资质时效</Divider>
      <Alert type="success">永久</Alert>
      <Divider orientation="left">授权项目成本</Divider>
      <Alert>0元</Alert>
      <Divider orientation="left">资质使用规范</Divider>
      <Alert type="error">
        <p class="text">合作期间务必遵守双方约定之规范</p>
        <p class="text">
          1、单授权码最近不得低于官方价格出售(当前为不得低于49元出售)，若发现核查发现则解除授权商资格不退款，情节严重的将追诉对我方损失的补偿

        </p>
        <p class="text">
          2、请勿授权违法违规擦边球等网站，将有连带责任风险。请遵守平台规范，共同营造良好环境
        </p>

     
      </Alert>




    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {


      };
    },

  };
</script>
<style lang="less">

.text{
  font-size: 15px;
  margin-bottom: 20px;
  letter-spacing:2px;
}

</style>